import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";

import { WeekPlanService } from "../../services/weekPlanService";
import logger from "../../core/utils/logger";


export const getUserWeekPlanInOrgByWeekAndYear=createAsyncThunk(
    'weekPlan/getUserWeekPlanInOrgInWeek',
    async({week, year, viewerMode = false}, {rejectWithValue})=>{
        try{
            const response=await WeekPlanService.getUserWeekPlan(week, year, viewerMode);
            logger.log("User week plan response:", JSON.stringify(response,null,2));
            return response;
        }catch(error){
            logger.error('Error:', error);
            // Check if the error is a 404 (Not Found)
      if (error.response && error.response.status === 404) {
        logger.warn("No week plan found, returning empty array.");
        return []; // Return an empty array instead of an error
      }

            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error getting week plan';
            throw new Error(errorMessage);
        }
    }
);



export const saveUserWeekPlan=createAsyncThunk(
    'weekPlan/saveUserWeekPlan',
    async({userWeekPlan, week, year},{rejectWithValue})=>{
        try{
            const response=await WeekPlanService.saveUserWeekPlan(userWeekPlan,week,year);
            logger.log("User week plan response:", response);
            return response;
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error saving week plan';
            throw new Error(errorMessage);
        }
    }
);
export const deleteUserWeekPlan=createAsyncThunk(
    'weekPlan/deleteUserWeekPlan',
    async({userId,week, year},{rejectWithValue})=>{
        try{
            const response=await WeekPlanService.deleteUserWeekPlan(userId,week,year);
            logger.log("User week plan response:", response);
            return response;
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error deleting week plan';
            throw new Error(errorMessage);
        }
    }
);
const initialState = {
    WeekPlanData: {
        weekPlanSchedules: [],
        loading: false,
        error: null
    }
};

const weekPlanSlice = createSlice({
    name: 'weekPlan',
    initialState,
    reducers: {
       clearWeekPlanState: (state) => {
            state.WeekPlanData.weekPlanSchedules = [];
            state.WeekPlanData.loading = false;
            state.WeekPlanData.error = null;
        }
    },
    extraReducers:(builder)=>{
        builder.addCase(getUserWeekPlanInOrgByWeekAndYear.pending,(state)=>{
            state.WeekPlanData.loading=true;
            state.WeekPlanData.error=null;
        });
        builder.addCase(getUserWeekPlanInOrgByWeekAndYear.fulfilled,(state,action)=>{
            state.WeekPlanData.weekPlanSchedules=action.payload;
            state.WeekPlanData.loading=false;
            state.WeekPlanData.error=null;
        });
        builder.addCase(getUserWeekPlanInOrgByWeekAndYear.rejected,(state,action)=>{
            state.WeekPlanData.loading=false;
            state.WeekPlanData.error=action.payload;
        });
        builder.addCase(saveUserWeekPlan.pending,(state)=>{
            state.WeekPlanData.loading=true;
            state.WeekPlanData.error=null;
        });
        builder.addCase(saveUserWeekPlan.fulfilled,(state,action)=>{
            state.WeekPlanData.weekPlanSchedules=action.payload;
            state.WeekPlanData.loading=false;
            state.WeekPlanData.error=null;
        });
        builder.addCase(saveUserWeekPlan.rejected,(state,action)=>{
            state.WeekPlanData.loading=false;
            state.WeekPlanData.error=action.payload;
        });
        builder.addCase(deleteUserWeekPlan.pending,(state)=>{
            state.WeekPlanData.loading=true;
            state.WeekPlanData.error=null;
        });
        builder.addCase(deleteUserWeekPlan.fulfilled,(state,action)=>{
            
            state.WeekPlanData.loading=false;
            state.WeekPlanData.error=null;
        });
        builder.addCase(deleteUserWeekPlan.rejected,(state,action)=>{
            state.WeekPlanData.loading=false;
            state.WeekPlanData.error=action.payload;
        });
       


    }
    
    }
);
export const {clearWeekPlanState}=weekPlanSlice.actions;
export default weekPlanSlice.reducer;